import {
    apiRequest,
    acmanajerialCreate,
    masterCategories
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", acmanajerialCreate, {
            body: query
        }, true)
    }

    fetchCategories = async (query) => {
        return await apiRequest("get", masterCategories, {
            params: query
        }, true)
    }
}

export default CreateRepository